module.exports = __webpack_public_path__ + "static/media/Паспорт GALAD Аврора LED.84f063d0.pdf";